import React from "react";
import {Navigate} from 'react-router-dom'

import * as AuthC from '../../utils/auth/AuthCognito';
import * as LoginForms from './LoginFormsComponent';



const LoginComponent = (props) => {
    if(AuthC.isCachedUserSessionActive()) {
    // if(props.auth.isAuthenticated) {
        console.log('Is Authenticated');
        return(
            <Navigate to={`/home}`} replace />
        );
    }
    else if(props.auth.cognitoState?.authenticationChallenge == null) {
        return(
            <LoginForms.LoginForm 
                auth={props.auth} 
                loginUser={props.loginUser}
                onLoginCallback={props.onLoginCallback}
            />
        );
    }
    else {
        return( 
            <LoginForms.ChangePasswordChallengeForm auth={props.auth} changePasswordChallenge={props.changePasswordChallenge}/>
        );
    }
};

export default LoginComponent;